import React from "react";
import View from "../../pages/teamsList";
import { Box } from "@material-ui/core";
import { Loading } from "../../ui/loader";
import "../../ui/styles.css";

class Teams extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      upcomingTeams: [],
      pastTeams: [],
    };
  }

  componentDidMount() {
    const isGroupBy = false;
    this.props.getTeams(isGroupBy);
  }

  mapPropsToState = (props) => {
    const past = [];
    const upcoming = [];
    if (props.teams) {
      const teams = props.teams;
      if (teams.length > 0) {
        for (let team of teams) {
          if (!team.is_past) {
            upcoming.push(team);
          } else {
            past.push(team);
          }
        }
      }
    }
    this.setState({ upcomingTeams: upcoming, pastTeams: past });
  };

  redirectToCreateTeam = () => {
    this.props.history.push("/teams/create");
  };
  redirectToTeamByID = (e) => {
    const id = e;
    this.props.history.push(`teams/${id}`);
  };
  componentDidUpdate(nextProps, nextState, nextContext) {
    if (nextProps.teams !== this.props.teams) {
      this.setState(this.mapPropsToState(this.props.teams));
    }

    return nextState;
  }

  render() {
    const { teams, loading } = this.props;
    const { upcomingTeams, pastTeams } = this.state;
    if (teams.loading) {
      return <Loading loading={teams.loading} />;
    }

    return (
      <Box border="1px solid #dcdcdc" className="rightMemberAreaScreen">
        <Box className="fontStyleHeadingProfile" mb={2}>
          Teams
        </Box>
        <Box>
          <View
            onRedirect={this.redirectToCreateTeam}
            onRedirectToTeamByID={this.redirectToTeamByID}
            teams={teams.teams}
            isLoading={loading}
            upcomingTeams={upcomingTeams}
            pastTeams={pastTeams}
          />
        </Box>
      </Box>
    );
  }
}

export default Teams;
